module.exports = __webpack_public_path__ + "media/src/website/images/locations/fridolfing/fridolfing_01-59d495bce71915000fef7e5015606475.jpg";